import { useState } from 'react';
import { SERVER_URL, UserInfo, RANK_OPTIONS } from '../../api';
import './Auth.css';

interface AuthProps {
  onAuthed: (token: string, user: UserInfo) => void;
}

type Mode = 'login' | 'register';

export default function Auth({ onAuthed }: AuthProps) {
  const [mode, setMode] = useState<Mode>('login');
  const [username, setUsername] = useState('');
  const [nickname, setNickname] = useState('');
  const [password, setPassword] = useState('');
  const [rank, setRank] = useState('25级');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const switchMode = (m: Mode) => {
    setMode(m);
    setError('');
  };

  const submit = async () => {
    setError('');
    if (!username.trim()) { setError('请输入用户名'); return; }
    if (mode === 'register' && !nickname.trim()) { setError('请输入昵称'); return; }
    if (!password) { setError('请输入密码'); return; }

    setBusy(true);
    try {
      const path = mode === 'login' ? '/api/auth/login' : '/api/auth/register';
      const body: Record<string, string> = { username: username.trim(), password };
      if (mode === 'register') {
        body.nickname = nickname.trim();
        body.rank = rank;
      }

      const res = await fetch(SERVER_URL + path, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });
      const data = await res.json();
      if (!res.ok || !data.ok) {
        setError(data.error || '操作失败，请重试');
        return;
      }
      onAuthed(data.token, data.user);
    } catch (e) {
      setError('无法连接服务器，请确认后端已启动');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth-wrap">
      <div className="auth-card">
        <h2>{mode === 'login' ? '登录' : '注册账号'}</h2>
        <p className="auth-sub">{mode === 'login' ? '欢迎回来，继续对弈' : '一人一账号，棋谱与战绩自动留存'}</p>

        <div className="auth-tabs">
          <button className={mode === 'login' ? 'active' : ''} onClick={() => switchMode('login')}>登录</button>
          <button className={mode === 'register' ? 'active' : ''} onClick={() => switchMode('register')}>注册</button>
        </div>

        <div className="auth-field">
          <label>用户名</label>
          <input
            type="text"
            placeholder="3-20 位字母/数字/下划线"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            maxLength={20}
            autoComplete="username"
          />
        </div>

        {mode === 'register' && (
          <div className="auth-field">
            <label>昵称（对局时显示）</label>
            <input
              type="text"
              placeholder="最长 20 字"
              value={nickname}
              onChange={(e) => setNickname(e.target.value)}
              maxLength={20}
            />
          </div>
        )}

        {mode === 'register' && (
          <div className="auth-field">
            <label>等级（你的棋力）</label>
            <select value={rank} onChange={(e) => setRank(e.target.value)} className="auth-select">
              {RANK_OPTIONS.map((r) => <option key={r} value={r}>{r}</option>)}
            </select>
          </div>
        )}

        <div className="auth-field">
          <label>密码</label>
          <input
            type="password"
            placeholder="至少 6 位"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            maxLength={64}
            autoComplete={mode === 'login' ? 'current-password' : 'new-password'}
            onKeyDown={(e) => e.key === 'Enter' && submit()}
          />
        </div>

        {error && <div className="auth-error">{error}</div>}

        <button className="auth-submit" onClick={submit} disabled={busy}>
          {busy ? '处理中...' : mode === 'login' ? '登录' : '注册并登录'}
        </button>
      </div>
    </div>
  );
}
